import type { HttpErrorResponse } from '@angular/common/http';

import { createActions, ngrxEvent } from '@core/ngrx-legacy';

import type { ViewboxLanguageItem, ViewboxTranslations } from './types';

const namespace = 'ViewboxLanguages';

export const ViewboxLanguagesActions = createActions(namespace, {
  load: ngrxEvent<string>(),
  loadSuccess: ngrxEvent<ViewboxLanguageItem[]>(),
  loadFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
  loadTranslation: ngrxEvent<{ language: string; host: string }>(),
  loadTranslationSuccess: ngrxEvent<ViewboxTranslations>(),
  loadTranslationFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
});
